// extracted by mini-css-extract-plugin
export default {"layout":"QuickDepositPopup__layout--1jw","popup":"QuickDepositPopup__popup--3Po"};